import $ from 'jquery';
import 'lazysizes';
import objectFitImages from 'object-fit-images';

$(function() {
	$('body').on('lazyloaded', '.lazyload', function() {
		objectFitImages(this);
	})
})
